<p>{{ formatDecimalsHelper.formatDecimal(value, system.attributes.decimal_places) }} <ng-content></ng-content></p>
